import { Component, ElementRef, Input, OnInit, Output, Renderer2, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { DhlFormControl } from '../../models/dhl-form-control';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonConfig } from 'src/app/common/configuration/common.config';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import { AppService } from 'src/app/app.service';
import { ErrorsConfig } from 'src/app/common/configuration/errors.config';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { DomEventService } from 'src/app/common/dom-event/dom-event.service';
import { FormService } from '../../services/form.service';
import {TranslateService} from '@ngx-translate/core';
import  {Constant}  from '../../../constants/constants';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service'

@Component({
    selector: 'app-form-field-order-line-autocomplete-v2',
    templateUrl: './form-field-order-line-autocomplete-v2.component.html',
    styleUrls: ['./form-field-order-line-autocomplete-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FormFieldOrderLineAutocompleteComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;

  @Input() fieldMetadata;
  @Output() fieldAction = new EventEmitter();
  @Output() controlValue = new EventEmitter();

  @ViewChild('formControl',{static: true}) formControl: ElementRef;
  @ViewChild('inputEle',{static: true}) inputEle: ElementRef;
  enum=Constant;
  placeholder: string = '';
  validationType: string = '';
  fieldType: string = '';
  fieldIcon: string = '';
  editField: boolean;
  isLoading: boolean;
  templateData: any;
  selfServiceConfig: boolean = false;
  orderFormSubmitted: any;
  orderForm: any;

  pickerToggle: boolean = false;

  // seach-com code
  public suggestionList: any[];
  private searchTerms = new Subject<any>();
  suggestion: boolean;
  public selectedItems: Array<any>;
  typing = false;
  searchStr = "";
  selection: string;
  noItemFound: boolean = false;
  noItemFoundError; selectFromListError;
  // make api call vars
  progressBar = false;
  color: String = 'primary';
  mode: String = 'indeterminate';
  isOpenAddItemPoup = false;
  addNewItem = false;
  clickEventSubscription: Subscription;
  keyUpEventSubscription: Subscription;
  keyUpTabEventSubscription: Subscription;

  constructor(
    private _eref: ElementRef,
    private renderer: Renderer2,
    private modalService: ModalService,
    private appService: AppService,
    private apiService: AppService,
    private domEventService: DomEventService,
    public translate: TranslateService,
    private formService: FormService,
    private alphaService: AlphaService,
    private cdr: ChangeDetectorRef,
  ) {
    this.suggestionList = [];
    this.suggestion = true;
  }

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    this.fieldType = this.fieldMetadata ? this.fieldMetadata.fieldType : 'search';
    this.fieldIcon = this.fieldMetadata ? this.fieldMetadata.fieldIcon : null;
    this.toggleDisable(this.configData['disabled']);
    if (this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);

    this.searchTerms.pipe(debounceTime(CommonConfig.ITEM_SEARCH_TIMEOUT))
      .subscribe(term => {
        this.makeapicall(term);
        console.log(term);
      });
    this.noItemFound = false;
    if(!this.frmGroup.get(this.configData.name)['itemArray'])
      this.frmGroup.get(this.configData.name)['itemArray'] = [];

    if(this.frmGroup.get(this.configData.name).value){
      this.frmGroup.get(this.configData.name)['itemArray'].push(
        this.frmGroup.get(this.configData.name).value)
    }
  //  this.frmGroup['itemArray'] = [];
    // this.frmGroup['secondaryText'] = '';
    // this.frmGroup['primaryText'] = '';
    this.noItemFoundError = ErrorsConfig.autocomplete.notFound;
    this.selectFromListError = ErrorsConfig.autocomplete.selectFromList;

   //   this.searchStr  = this.frmGroup.get(this.configData.name).value;
    this.clickEventSubscription = this.domEventService.click.subscribe((e: MouseEvent) => this.onWindowClick(e));
    this.keyUpEventSubscription = this.domEventService.keyUp.subscribe((e: KeyboardEvent) => this.onWindowClick(e));
    this.keyUpTabEventSubscription = this.domEventService.keyUpTab.subscribe((e: KeyboardEvent) => this.onWindowClick(e));
  }
  getFormStatus(e) {
    this.orderFormSubmitted = e;
  }

  getForm(e) {
    this.orderForm = e;
  }

  normalView() {
    throw new Error('Method not implemented.');
  }


  ngAfterViewInit() {
    this.placeholder = this.configData.placeHolder;
    let templtName = localStorage.getItem('templateName');
    if (templtName  === 'orderViewEdit' || templtName  === "releaseOrderViewEdit") {
      //this.frmGroup['itemArray'].push(this.frmGroup.get(this.configData.name).value);
    }
    this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, this.frmGroup.value, true);

    if(this.frmGroup.get(this.configData.name).value){
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
  }
  AddNewItem($event){
    this.isOpenAddItemPoup = true;
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'ADD_NEW_ITEM');
    if (event) {
      this.sendToSource(event);
    }
  }
   /** Common Method to check event exist in template */
   checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, row = {}) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
    }
    this.apiService._commonComponentSubject.next(eventData);
  }
  fieldValueValidation(validations) {
    validations.forEach((validataion: string | any) => {
      let element = (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
    }, this);
  }

  toggleDisable(disabled) {
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
      this.formControl.nativeElement.parentElement.classList.add('disabled');
    } else {
      this.frmGroup.get(this.configData.name).enable();
      this.formControl.nativeElement.parentElement.classList.remove('disabled');
    }
  }

  popFieldAction(e) {
    this.fieldAction.emit(e);
  }

  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.typing = false;
      if (!this.isOpenAddItemPoup)
      this.addNewItem = false;
      let selection: any = this.frmGroup.get(this.configData.name).value;
      if (selection !== '') {
        if (this.frmGroup.get(this.configData.name)['itemArray'] && this.frmGroup.get(this.configData.name)['itemArray'].indexOf(selection) < 0) {
          this.frmGroup.get(this.configData.name).setErrors({ 'selectFromList': true });
        }
      }
    }
  }

  controlValueChange(e) {
    // this.controlValue.emit(e);
    console.log('change---->', e.target.value.trim())
    // this.frmGroup.get(this.configData.name).setValue(e.target.value.trim());
    //Form Group validation services
    this.formService.groupValidationSrv(this.configData, this.frmGroup);
  }

  setOnFocus($event) {
    if (($event.target.value.trim().length >= 3) && this.suggestionList.length ) {
      this.typing = true;
    }
  }

  onkeyupHandler($event) {
    // if ($event.target.value.trim().length >= 3) {
    if (this.frmGroup.get(this.configData.name).value !== '') {
      if (this.frmGroup.get(this.configData.name)['itemArray'] && this.frmGroup.get(this.configData.name)['itemArray'].indexOf(this.frmGroup.get(this.configData.name).value) > -1 ||
        (this.suggestionList.length > 0 && this.selection === this.frmGroup.get(this.configData.name).value)) {
        return;
      } else {
        this.selection = this.frmGroup.get(this.configData.name).value;
      }
    }

    this.frmGroup['tempControlIcon'] = false
    this.frmGroup['hazmatIcon'] = false;
    this.noItemFound = false;
    this.frmGroup['secondaryText'] = '';
    this.configData.hintText = '';
    let searchText = $event.currentTarget.value;
    if (searchText.length > 2 && searchText != null) {
      this.suggestionList = [];
      this.searchTerms.next(searchText);
    } else {
      this.typing = false;
      this.suggestionList = [];
      this.frmGroup['itemArray'] = [];
      this.frmGroup.get(this.configData.name)['itemArray'] = [];
    }
  }

  selectItem($event, data, disabled) {
    this.noItemFound = false;
    // icons
    if (data.tempControl) {
      this.frmGroup['tempControlIcon'] = true;
    }
    if (data.hazmat) {
      this.frmGroup['hazmatIcon'] = true;
    }

    if(data.nmfcarticle !== undefined && data.nmfcclass !== undefined){
      if(data.nmfcarticle !== '' || data.nmfcclass !== ''){
        if(data.nmfcarticle !== ''){
          this.frmGroup['secondaryText'] = 'Article: ' + data.nmfcarticle;
        }
        if(data.nmfcclass !== ''){
          this.frmGroup['secondaryText'] = this.frmGroup['secondaryText'] + (data.nmfcarticle !== '' ? ', ': '') + 'Class: ' + data.nmfcclass;
        }
      }
    }

    if (data.itemId) {
      this.frmGroup.get(this.configData.name + "Id").setValue(data.itemId);
    }
    this.frmGroup.get(this.configData.name).setValue(data.primaryValue);
    this.suggestionList = [];
    this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, data);
  }

  makeapicall(searchText) {
    this.progressBar = true;
    this.addNewItem = false;
    this.typing = true;

    let url = APP_Constants.ITEM_SEARCH_URL
    + localStorage.getItem('customerCode')
    + "&searchString=" + searchText.toUpperCase()
    + '&userId=' + localStorage.getItem('userName');


    this.appService.makeHttpGetRequest(url)
      .subscribe(data => {
        this.progressBar = false;
        if (data['message'].statusCode === APP_Constants.SUCCESS_CODE) {
          this.suggestionList = data['items'];
          this.suggestionList.map((item) => {
            item['primaryValue'] = item.itemId + ' - ' + item.itemName;
            this.frmGroup.get(this.configData.name)['itemArray'].push(item.itemId + ' - ' + item.itemName);
          });
          this.cdr.detectChanges();
        } else {
          if (this.configData['addNewItem']) {
            this.addNewItem = true;
          }
          this.suggestionList = [];
          this.frmGroup['itemArray'] = [];
          this.noItemFound = true;
          this.configData.validation.forEach(elem => {
            if (elem === 'SelectFromList') {
              this.frmGroup.get(this.configData.name).setErrors({ 'NoItemFound': { 'message': '' } });
            }
          });
        }
      }, (err) => {
        this.progressBar = false;
        let modal = new Modal({
          action: false, name: 'itemSearch', title: 'Item Search', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
  }

  close() {
    // this.searchStr = "";
    this.frmGroup.get(this.configData.name).setValue("");
    this.typing = false;
    this.renderer.removeAttribute(this.inputEle.nativeElement, 'placeholder');
    this.renderer.removeClass(this.inputEle.nativeElement.parentElement, 'active');
  }

  ngOnDestroy() {
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
    if (this.keyUpEventSubscription) {
      this.keyUpEventSubscription.unsubscribe();
    }
    if (this.keyUpTabEventSubscription) {
      this.keyUpTabEventSubscription.unsubscribe();
    }
  }
}
